<nz-row class="main-font">
  <!-- Contenitore grafico -->
  <nz-col
    [nzXs]="{ span: 24, offset: 0 }"
    [nzSm]="{ span: 24, offset: 0 }"
    [nzMd]="{ span: 12, offset: 0 }"
    [nzLg]="{ span: 12, offset: 0 }"
    class="container-competences d-flex justify-content-center"
    [ngStyle]="{ height: height + 'px' }">
    <canvas #myRadarChart class="chart"></canvas>
  </nz-col>

  <!-- Contenitore competenze -->
  <nz-col
    [nzXs]="{ span: 24, offset: 0 }"
    [nzSm]="{ span: 24, offset: 0 }"
    [nzMd]="{ span: 12, offset: 0 }"
    [nzLg]="{ span: 12, offset: 0 }"
    class="container-competences"
    [ngStyle]="{ height: height + 'px' }">
    <nz-row
      *ngFor="let competence of competences"
      class="card-competences mb-3"
      [ngClass]="{ 'card-higlighted': competence.is_highlighted }">
      <nz-col nzSpan="3">
        <img
          [src]="utilityService.getSanitizeUrl(competence.img_path)"
          [alt]="competence.alias"
          [nz-tooltip]="competence.description"
          class="img-competence" />
      </nz-col>
      <nz-col nzSpan="15" class="d-flex align-items-center">
        <p class="text-alias mb-0">{{ competence.alias }}</p>
      </nz-col>
      <nz-col
        nzSpan="3"
        class="d-flex justify-content-center align-items-center">
        <img
          src="assets/images/peoples.svg"
          alt="FB360"
          height="16px"
          width="16px"
          class="me-1" />
        <p class="mb-0 vote">{{ competence.review_evaluation || 0 }}</p>
      </nz-col>
      <nz-col
        nzSpan="3"
        class="d-flex justify-content-center align-items-center">
        <img
          src="assets/images/people.svg"
          alt="auto"
          height="16px"
          width="16px"
          class="me-1" />
        <p class="mb-0 vote">{{ competence.auto_evaluation }}</p>
      </nz-col>
    </nz-row>
  </nz-col>
</nz-row>
